import { CheckCircle2, XCircle } from 'lucide-react';
import type { TriggerLogEntry, TriggerLogResultConfig } from './log-types';

const SUCCESS_CONFIG: TriggerLogResultConfig = {
  label: 'Успех',
  icon: CheckCircle2,
  className: 'bg-green-100 text-green-800',
};

const ERROR_CONFIG: TriggerLogResultConfig = {
  label: 'Ошибка',
  icon: XCircle,
  className: 'bg-red-100 text-red-800',
};

/**
 * Визуальная конфигурация результата выполнения триггера.
 * API отдаёт только boolean `success`, поэтому вариантов два.
 */
export function getTriggerLogResultConfig(log: TriggerLogEntry): TriggerLogResultConfig {
  return log.success ? SUCCESS_CONFIG : ERROR_CONFIG;
}
